import { Page, PageRequest } from '$synapse/models';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DashboardService } from '$synapse/services';
import { CandidateSummary } from '$synapse/dtos';

@Injectable({
  providedIn: 'root',
})
export class CandidatesResolver {
  private readonly _dashboardApi = inject(DashboardService);

  resolve(route: ActivatedRouteSnapshot): Observable<Page<CandidateSummary>> {
    return this._dashboardApi.findCandidatesWithAssessmentsStats(
      new PageRequest(route.queryParams)
    );
  }
}
